export default "__VITE_ASSET__8054ab60__"